/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ColumnsInterface, FilterType } from '@irian-ro/util-table';

export class ColumnModel implements ColumnsInterface {
  field: string | undefined = undefined;
  filterType?: FilterType = 'input';
  filterMatchMode?: string = 'contains'; //Create a type
  filterPlaceholder?: string;
  pipe?: any;
  header!: string;

  constructor(
    field: string,
    label: string,
    filterType?: FilterType,
    filterMatchMode?: string,
    filterPlaceholder?: string,
    pipe?: any
  ) {
    this.field = field;
    this.label = label;
    this.filterType = filterType;
    this.filterMatchMode = filterMatchMode;
    this.filterPlaceholder = filterPlaceholder;
    this.pipe = pipe;
  }

  private _label?: string;

  get label(): string | undefined {
    return this._label;
  }

  set label(value: string) {
    this._label = value;
  }
}
